import createTypes from 'redux-create-action-types';

export default createTypes(
  'GET_ALL_DOCUMENTS',
  'GET_DOCUMENT_MANAGEMENT_FILTERS_DROPDOWN',
  'GET_PENDING_REVIEW_DOCUMENTS',
  'GET_EXPIRED_DOCUMENTS',
  'GET_ARCHIVED_DOCUMENTS',
  'GET_TRASH_DOCUMENTS',
  'GET_DOCUMENT_MANAGEMENT_FILTER_TYPES',
  'GET_DOCUMENT_MANAGEMENT_FILTER_SOURCES',
  'GET_DOCUMENT_MANAGEMENT_STORAGE',
  'GET_PRODUCT_ALL_FILES',
  'GET_PRODUCT_ALL_FILES1',
  'GET_PRODUCT_ARCHIVED_FILES',
  'CREATE_PRODUCT_FOLDER',
  'GET_SUPPLIER_ALL_FILES',
  'GET_SUPPLIER_ALL_FILES1',
  'GET_SUPPLIER_ARCHIVED_FILES',
  'CREATE_SUPPLIER_FOLDER',
  'GET_FACTORY_ALL_FILES',
  'GET_FACTORY_ALL_FILES1',
  'GET_FACTORY_ARCHIVED_FILES',
  'CREATE_FACTORY_FOLDER'
);
